// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
  background: #f8fafc;
  color: #1e293b;
  line-height: 1.6;
}

/* Main Container */
.flatowner-main-container {
    min-height: 100vh;
    /* background: linear-gradient(135deg, #ffffff 0%, #fff8f4 100%); */
    padding: 2rem;
}
/* Header */
.flatowner-header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 0;
}

.flatowner-header-content {
  max-width: 800px;
  margin: 0 auto;
}

.flatowner-title {
    font-size: 2.5rem;
    font-weight: 800;
    color: #120e0c;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.flatowner-title-icon {
    color: #d85200;
    font-size: 2.5rem;
}

.flatowner-subtitle {
  font-size: 1.125rem;
  color: #94a3b8;
  font-weight: 400;
}

/* Action Bar */
.flatowner-action-bar {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.flatowner-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.flatowner-btn-primary {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
}

.flatowner-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
}

.flatowner-btn-secondary {
  background: linear-gradient(135deg, #6b7280, #4b5563);
  color: white;
}

.flatowner-btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(107, 114, 128, 0.4);
}

.flatowner-btn-success {
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
}

.flatowner-btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
}

.flatowner-btn-info {
  background: linear-gradient(135deg, #06b6d4, #0891b2);
  color: white;
}

.flatowner-btn-info:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(6, 182, 212, 0.4);
}

.flatowner-btn-danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: white;
}

.flatowner-btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4);
}

/* Customer Card */
.flatowner-customer-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  margin: 0 auto 2rem;
  max-width: 1200px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.flatowner-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #f1f5f9;
}

.flatowner-flat-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.flatowner-flat-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.flatowner-icon {
    color: #d85200;
}
.flatowner-edit-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #f8fafc;
  color: #475569;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.flatowner-edit-btn:hover {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.flatowner-customer-name {
  text-align: right;
}

.flatowner-customer-name h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.flatowner-customer-name p {
  font-size: 1rem;
  color: #64748b;
  font-weight: 500;
}

/* Details Grid */
.flatowner-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
}

.flatowner-info-section {
  background: #f8fafc;
  border-radius: 16px;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
}

.flatowner-section-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #e2e8f0;
}

.flatowner-section-icon {
    color: #d85200;
    font-size: 1.25rem;
}

.flatowner-info-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.flatowner-info-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.flatowner-info-item:hover {
  border-color: #3b82f6;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
}

.flatowner-item-icon {
    color: #d85200;
    font-size: 1rem;
    flex-shrink: 0;
}

.flatowner-label {
  font-weight: 600;
  color: #475569;
  min-width: 80px;
}

.flatowner-value {
  color: #1e293b;
  font-weight: 500;
  flex: 1 1;
}

/* Loading State */
.flatowner-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  color: white;
}

.flatowner-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #374151;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: flatowner-spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes flatowner-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Modal Styles */
.flatowner-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}

.flatowner-modal {
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  scrollbar-width: none;
}

.flatowner-modal-large {
  max-width: 900px;
}

.flatowner-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 20px 20px 0 0;
}

.flatowner-modal-header h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
}

.flatowner-header-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.flatowner-close-btn {
  width: 40px;
  height: 40px;
  background: #f1f5f9;
  color: #64748b;
  border: none;
  border-radius: 10px;
  font-size: 1.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.flatowner-close-btn:hover {
  background: #e2e8f0;
  color: #475569;
}

/* Form Styles */
.flatowner-form {
  padding: 2rem;
}

.flatowner-form-section {
  margin-bottom: 2rem;
}

.flatowner-form-section h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e2e8f0;
}

.flatowner-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.flatowner-form-group {
  margin-bottom: 1.5rem;
}

.flatowner-form-group-full {
  grid-column: 1 / -1;
}

.flatowner-form-group label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}

.flatowner-input,
.flatowner-select,
.flatowner-textarea {
  width: 100%;
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.flatowner-input:focus,
.flatowner-select:focus,
.flatowner-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.flatowner-textarea {
  resize: vertical;
  min-height: 80px;
}

.flatowner-form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: flex-end;
}

/* Installment Content */
.flatowner-installment-content {
  padding: 2rem;
}

.flatowner-residency-details {
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid #e2e8f0;
}

.flatowner-residency-details h4 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
}

.flatowner-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.flatowner-summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.flatowner-summary-label {
  font-weight: 600;
  color: #64748b;
}

.flatowner-summary-value {
  font-weight: 700;
  color: #1e293b;
}

/* Table Styles */
.flatowner-table-container {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.flatowner-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.flatowner-table th,
.flatowner-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.flatowner-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.flatowner-table td {
  color: #1e293b;
}

.flatowner-table tr:hover {
  background: #f8fafc;
}

.flatowner-payment-method {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: #dbeafe;
  color: #1e40af;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}

.flatowner-action-column {
  width: 120px;
}

.flatowner-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0 0.25rem;
}

.flatowner-btn-edit {
  background: #dbeafe;
  color: #1e40af;
}

.flatowner-btn-edit:hover {
  background: #bfdbfe;
  transform: scale(1.1);
}

.flatowner-btn-delete {
  background: #fee2e2;
  color: #dc2626;
}

.flatowner-btn-delete:hover {
  background: #fecaca;
  transform: scale(1.1);
}

/* Customer Slip Styles */
.flatowner-slip-content {
  padding: 2rem;
  background: white;
  font-family: Arial, sans-serif;
}

.flatowner-slip-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 3px solid #10b981;
}

.flatowner-slip-header h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.flatowner-slip-header p {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.flatowner-slip-body {
  margin-top: 1rem;
}

.flatowner-slip-details {
  margin: 1.5rem 0;
}

.flatowner-slip-table {
  width: 100%;
  max-width: 400px;
  border-collapse: collapse;
  border: 1px solid #6b7280;
}

.flatowner-slip-table td {
  border: 1px solid #6b7280;
  padding: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
}

.flatowner-slip-text {
  margin: 1.5rem 0;
  font-size: 1rem;
  line-height: 1.6;
  text-align: center;
}

.flatowner-slip-amount {
  border: 2px solid #1e293b;
  border-radius: 25px;
  padding: 0.5rem 1rem;
  display: inline-block;
  margin: 1rem 0;
}

.flatowner-slip-signatures {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .flatowner-main-container {
    padding: 1rem;
  }

  .flatowner-title {
    font-size: 2rem;
    flex-direction: column;
    gap: 0.5rem;
  }

  .flatowner-title-icon {
    font-size: 2rem;
  }

  .flatowner-action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .flatowner-btn {
    justify-content: center;
  }

  .flatowner-customer-card {
    padding: 1.5rem;
  }

  .flatowner-card-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .flatowner-flat-info {
    flex-direction: column;
    gap: 0.5rem;
  }

  .flatowner-customer-name {
    text-align: center;
  }

  .flatowner-details-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .flatowner-form-grid {
    grid-template-columns: 1fr;
  }

  .flatowner-form-actions {
    flex-direction: column;
  }

  .flatowner-summary-grid {
    grid-template-columns: 1fr;
  }

  .flatowner-modal {
    margin: 0.5rem;
    max-height: 95vh;
  }

  .flatowner-modal-header {
    padding: 1rem 1.5rem;
  }

  .flatowner-form {
    padding: 1.5rem;
  }

  .flatowner-table-container {
    font-size: 0.875rem;
  }

  .flatowner-table th,
  .flatowner-table td {
    padding: 0.75rem 0.5rem;
  }
}

@media (max-width: 480px) {
  .flatowner-title {
    font-size: 1.75rem;
  }

  .flatowner-subtitle {
    font-size: 1rem;
  }

  .flatowner-customer-card {
    padding: 1rem;
  }

  .flatowner-info-section {
    padding: 1rem;
  }

  .flatowner-info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .flatowner-label {
    min-width: auto;
  }

  .flatowner-modal {
    margin: 0.25rem;
  }

  .flatowner-form {
    padding: 1rem;
  }

  .flatowner-slip-content {
    padding: 1rem;
  }

  .flatowner-slip-header h2 {
    font-size: 1.5rem;
  }

  .flatowner-slip-signatures {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
}

/* Animation Classes */
@keyframes flatowner-fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.flatowner-customer-card {
  animation: flatowner-fadeIn 0.6s ease-out;
}

.flatowner-info-section {
  animation: flatowner-fadeIn 0.6s ease-out;
}

.flatowner-info-section:nth-child(2) {
  animation-delay: 0.1s;
}

.flatowner-info-section:nth-child(3) {
  animation-delay: 0.2s;
}

/* Accessibility */
.flatowner-input:focus,
.flatowner-select:focus,
.flatowner-textarea:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Print Styles */
@media print {
  .flatowner-action-bar,
  .flatowner-modal-header,
  .flatowner-action-btn,
  .flatowner-edit-btn {
    display: none;
  }

  .flatowner-customer-card {
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }

  .flatowner-slip-content {
    padding: 0;
  }
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .flatowner-main-container {
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .flatowner-btn {
    border: 2px solid currentColor;
  }

  .flatowner-info-item {
    border: 2px solid #1e293b;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/addflat/FlatOwner.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;cACY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,mEAAmE;IACnE,aAAa;AACjB;AACA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;IACI,cAAc;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;;;;IAIE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,6DAA6D;EAC/D;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    sans-serif;\n  background: #f8fafc;\n  color: #1e293b;\n  line-height: 1.6;\n}\n\n/* Main Container */\n.flatowner-main-container {\n    min-height: 100vh;\n    /* background: linear-gradient(135deg, #ffffff 0%, #fff8f4 100%); */\n    padding: 2rem;\n}\n/* Header */\n.flatowner-header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding: 2rem 0;\n}\n\n.flatowner-header-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.flatowner-title {\n    font-size: 2.5rem;\n    font-weight: 800;\n    color: #120e0c;\n    margin-bottom: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.flatowner-title-icon {\n    color: #d85200;\n    font-size: 2.5rem;\n}\n\n.flatowner-subtitle {\n  font-size: 1.125rem;\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n/* Action Bar */\n.flatowner-action-bar {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.flatowner-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.5rem;\n  border: none;\n  border-radius: 12px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.flatowner-btn-primary {\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: white;\n}\n\n.flatowner-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);\n}\n\n.flatowner-btn-secondary {\n  background: linear-gradient(135deg, #6b7280, #4b5563);\n  color: white;\n}\n\n.flatowner-btn-secondary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(107, 114, 128, 0.4);\n}\n\n.flatowner-btn-success {\n  background: linear-gradient(135deg, #10b981, #059669);\n  color: white;\n}\n\n.flatowner-btn-success:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);\n}\n\n.flatowner-btn-info {\n  background: linear-gradient(135deg, #06b6d4, #0891b2);\n  color: white;\n}\n\n.flatowner-btn-info:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(6, 182, 212, 0.4);\n}\n\n.flatowner-btn-danger {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: white;\n}\n\n.flatowner-btn-danger:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4);\n}\n\n/* Customer Card */\n.flatowner-customer-card {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  margin: 0 auto 2rem;\n  max-width: 1200px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n}\n\n.flatowner-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 2px solid #f1f5f9;\n}\n\n.flatowner-flat-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.flatowner-flat-number {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.flatowner-icon {\n    color: #d85200;\n}\n.flatowner-edit-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  background: #f8fafc;\n  color: #475569;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.flatowner-edit-btn:hover {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n.flatowner-customer-name {\n  text-align: right;\n}\n\n.flatowner-customer-name h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 0.25rem;\n}\n\n.flatowner-customer-name p {\n  font-size: 1rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n/* Details Grid */\n.flatowner-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 2rem;\n}\n\n.flatowner-info-section {\n  background: #f8fafc;\n  border-radius: 16px;\n  padding: 1.5rem;\n  border: 1px solid #e2e8f0;\n}\n\n.flatowner-section-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.flatowner-section-icon {\n    color: #d85200;\n    font-size: 1.25rem;\n}\n\n.flatowner-info-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.flatowner-info-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.flatowner-info-item:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);\n}\n\n.flatowner-item-icon {\n    color: #d85200;\n    font-size: 1rem;\n    flex-shrink: 0;\n}\n\n.flatowner-label {\n  font-weight: 600;\n  color: #475569;\n  min-width: 80px;\n}\n\n.flatowner-value {\n  color: #1e293b;\n  font-weight: 500;\n  flex: 1;\n}\n\n/* Loading State */\n.flatowner-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem;\n  color: white;\n}\n\n.flatowner-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #374151;\n  border-top: 4px solid #3b82f6;\n  border-radius: 50%;\n  animation: flatowner-spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes flatowner-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Modal Styles */\n.flatowner-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 1rem;\n}\n\n.flatowner-modal {\n  background: white;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  scrollbar-width: none;\n}\n\n.flatowner-modal-large {\n  max-width: 900px;\n}\n\n.flatowner-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  border-radius: 20px 20px 0 0;\n}\n\n.flatowner-modal-header h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.flatowner-header-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.flatowner-close-btn {\n  width: 40px;\n  height: 40px;\n  background: #f1f5f9;\n  color: #64748b;\n  border: none;\n  border-radius: 10px;\n  font-size: 1.25rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.flatowner-close-btn:hover {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n/* Form Styles */\n.flatowner-form {\n  padding: 2rem;\n}\n\n.flatowner-form-section {\n  margin-bottom: 2rem;\n}\n\n.flatowner-form-section h4 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.flatowner-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.flatowner-form-group {\n  margin-bottom: 1.5rem;\n}\n\n.flatowner-form-group-full {\n  grid-column: 1 / -1;\n}\n\n.flatowner-form-group label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n\n.flatowner-input,\n.flatowner-select,\n.flatowner-textarea {\n  width: 100%;\n  padding: 0.875rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.flatowner-input:focus,\n.flatowner-select:focus,\n.flatowner-textarea:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.flatowner-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.flatowner-form-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n  justify-content: flex-end;\n}\n\n/* Installment Content */\n.flatowner-installment-content {\n  padding: 2rem;\n}\n\n.flatowner-residency-details {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  border: 1px solid #e2e8f0;\n}\n\n.flatowner-residency-details h4 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 1rem;\n}\n\n.flatowner-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.flatowner-summary-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.flatowner-summary-label {\n  font-weight: 600;\n  color: #64748b;\n}\n\n.flatowner-summary-value {\n  font-weight: 700;\n  color: #1e293b;\n}\n\n/* Table Styles */\n.flatowner-table-container {\n  overflow-x: auto;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.flatowner-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n}\n\n.flatowner-table th,\n.flatowner-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.flatowner-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.flatowner-table td {\n  color: #1e293b;\n}\n\n.flatowner-table tr:hover {\n  background: #f8fafc;\n}\n\n.flatowner-payment-method {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  background: #dbeafe;\n  color: #1e40af;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.flatowner-action-column {\n  width: 120px;\n}\n\n.flatowner-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin: 0 0.25rem;\n}\n\n.flatowner-btn-edit {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.flatowner-btn-edit:hover {\n  background: #bfdbfe;\n  transform: scale(1.1);\n}\n\n.flatowner-btn-delete {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.flatowner-btn-delete:hover {\n  background: #fecaca;\n  transform: scale(1.1);\n}\n\n/* Customer Slip Styles */\n.flatowner-slip-content {\n  padding: 2rem;\n  background: white;\n  font-family: Arial, sans-serif;\n}\n\n.flatowner-slip-header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 3px solid #10b981;\n}\n\n.flatowner-slip-header h2 {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n}\n\n.flatowner-slip-header p {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-bottom: 0.25rem;\n}\n\n.flatowner-slip-body {\n  margin-top: 1rem;\n}\n\n.flatowner-slip-details {\n  margin: 1.5rem 0;\n}\n\n.flatowner-slip-table {\n  width: 100%;\n  max-width: 400px;\n  border-collapse: collapse;\n  border: 1px solid #6b7280;\n}\n\n.flatowner-slip-table td {\n  border: 1px solid #6b7280;\n  padding: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.flatowner-slip-text {\n  margin: 1.5rem 0;\n  font-size: 1rem;\n  line-height: 1.6;\n  text-align: center;\n}\n\n.flatowner-slip-amount {\n  border: 2px solid #1e293b;\n  border-radius: 25px;\n  padding: 0.5rem 1rem;\n  display: inline-block;\n  margin: 1rem 0;\n}\n\n.flatowner-slip-signatures {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 2rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e2e8f0;\n  font-weight: 600;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .flatowner-main-container {\n    padding: 1rem;\n  }\n\n  .flatowner-title {\n    font-size: 2rem;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .flatowner-title-icon {\n    font-size: 2rem;\n  }\n\n  .flatowner-action-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .flatowner-btn {\n    justify-content: center;\n  }\n\n  .flatowner-customer-card {\n    padding: 1.5rem;\n  }\n\n  .flatowner-card-header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .flatowner-flat-info {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .flatowner-customer-name {\n    text-align: center;\n  }\n\n  .flatowner-details-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .flatowner-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .flatowner-form-actions {\n    flex-direction: column;\n  }\n\n  .flatowner-summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .flatowner-modal {\n    margin: 0.5rem;\n    max-height: 95vh;\n  }\n\n  .flatowner-modal-header {\n    padding: 1rem 1.5rem;\n  }\n\n  .flatowner-form {\n    padding: 1.5rem;\n  }\n\n  .flatowner-table-container {\n    font-size: 0.875rem;\n  }\n\n  .flatowner-table th,\n  .flatowner-table td {\n    padding: 0.75rem 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .flatowner-title {\n    font-size: 1.75rem;\n  }\n\n  .flatowner-subtitle {\n    font-size: 1rem;\n  }\n\n  .flatowner-customer-card {\n    padding: 1rem;\n  }\n\n  .flatowner-info-section {\n    padding: 1rem;\n  }\n\n  .flatowner-info-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .flatowner-label {\n    min-width: auto;\n  }\n\n  .flatowner-modal {\n    margin: 0.25rem;\n  }\n\n  .flatowner-form {\n    padding: 1rem;\n  }\n\n  .flatowner-slip-content {\n    padding: 1rem;\n  }\n\n  .flatowner-slip-header h2 {\n    font-size: 1.5rem;\n  }\n\n  .flatowner-slip-signatures {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n}\n\n/* Animation Classes */\n@keyframes flatowner-fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.flatowner-customer-card {\n  animation: flatowner-fadeIn 0.6s ease-out;\n}\n\n.flatowner-info-section {\n  animation: flatowner-fadeIn 0.6s ease-out;\n}\n\n.flatowner-info-section:nth-child(2) {\n  animation-delay: 0.1s;\n}\n\n.flatowner-info-section:nth-child(3) {\n  animation-delay: 0.2s;\n}\n\n/* Accessibility */\n.flatowner-input:focus,\n.flatowner-select:focus,\n.flatowner-textarea:focus {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\nbutton:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Print Styles */\n@media print {\n  .flatowner-action-bar,\n  .flatowner-modal-header,\n  .flatowner-action-btn,\n  .flatowner-edit-btn {\n    display: none;\n  }\n\n  .flatowner-customer-card {\n    box-shadow: none;\n    border: 1px solid #e2e8f0;\n  }\n\n  .flatowner-slip-content {\n    padding: 0;\n  }\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  .flatowner-main-container {\n    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  }\n}\n\n/* High Contrast Mode */\n@media (prefers-contrast: high) {\n  .flatowner-btn {\n    border: 2px solid currentColor;\n  }\n\n  .flatowner-info-item {\n    border: 2px solid #1e293b;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
